import { render, staticRenderFns } from "./portada.vue?vue&type=template&id=774e409f&scoped=true&"
import script from "./portada.vue?vue&type=script&lang=js&"
export * from "./portada.vue?vue&type=script&lang=js&"
import style0 from "./portada.vue?vue&type=style&index=0&id=774e409f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e409f",
  null
  
)

export default component.exports